import React from "react";
import { connect } from "../../base/redux";
import LayoutPaging from "./LayoutPaging";
import PinFilm from "./PinFilm";
import RemoteFilm from "./RemoteFilm";
import { PAGING_TYPE } from "../constants";

function UserFilm({
    includePin, isVertical, style, isDualMonitor
}) {
    const remote = () => {
        return (
            <>
                <LayoutPaging type={PAGING_TYPE.PREV} isVertical={isVertical} />
                    { !isDualMonitor ? <div className={`${ isVertical ? 'top' : 'left'}`}>
                        <RemoteFilm style={style} />
                        </div> : <RemoteFilm style={style} />
                    }
                <LayoutPaging type={PAGING_TYPE.NEXT} isVertical={isVertical} />
            </>
        )
    }
    return (
        <>
            { !includePin ? 
                <>
                    <PinFilm onlyOne={false} isStyle={false}  />
                    { remote() }
                </>
            : 
                remote()
            }
        </>
    )
}

function _mapStateToProps(state) {
    const includePin = state['features/video-layout-mode'].includePin;
    return {
        includePin
    }
}

export default connect(_mapStateToProps)(UserFilm);